import { render, staticRenderFns } from "./NetworkTrainingHome.vue?vue&type=template&id=f04dc8a2"
import script from "./NetworkTrainingHome.vue?vue&type=script&lang=js"
export * from "./NetworkTrainingHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports